import cn from 'classnames'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { appError } from '../../redux/slices/app'
import { Store } from '../../redux/store'
import Modal from '../Presentational/Modal/index'
import styles from './style.module.scss'


const Error: FC = (_) => {
    const { t } = useTranslation()
    const error = useSelector((state: Store) => state.App.error)
    const dispatch = useDispatch()
    // const [showDetails, setshowDetails] = useState(true)

    const close = () => {
        dispatch(appError(null))
    }

    /*     const detailsClick = useCallback(() => {
            setshowDetails(showDetails ? false : true)
        }, [showDetails])
     */
    const custom = useMemo(() => {
        if (error?.type === 'custom')
            return (<>
                <div className={styles.title}>
                    {error!.caption
                        ? error!.caption
                        : t('common:appError.caption')}
                </div>
                <div className={styles.text}>
                    {error!.text}
                    {error!.description && <>
                        <br />
                        {error!.description}
                    </>}
                </div>
            </>)
        return null
    }, [error, t])

    const status = useMemo(() => {
        if (error?.type === 'status')
            return (
                <>
                    <div className={styles.title}>
                        {t('common:appError.caption')}
                    </div>
                    <div className={styles.text}>
                        {t(error!.status)}
                    </div>
                    {/* {error!.response &&
                        <div className={styles.response}>
                            <div className={styles["hide-link"]} onClick={detailsClick}>
                                {showDetails ? t('common:hide_details')
                                    : t('common:show_details')}
                            </div>
                            {showDetails && <pre className={styles.text}>
                                {error!.response}
                            </pre>}
                        </div>} */}
                </>
            )
        return null
    }, [error, t])

    return <Modal
        isOpen={!!error}
        onModalClose={close}
        showCross={false}
        cardClassName={styles.card}
    >
        {error && <div className={styles.container}>
            {custom}
            {status}
            <button className={cn('green', styles.button)} onClick={close}>
                {t('common:appError.button')}
            </button>
        </div>
        }
    </Modal>

}


export default Error
